import { User } from '../../core/models/user.model';

export function userHasProfilePhoto(user: User | null | undefined): boolean {
  if (!user) {
    return false;
  }
  const img = user.profileImage;
  if (img && ((img.thumb?.length ?? 0) > 0 || (img.small?.length ?? 0) > 0)) {
    return true;
  }
  return typeof user.avatar === 'string' && user.avatar.length > 0;
}

export function userHasUsername(user: User | null | undefined): boolean {
  return (user?.username?.trim().length ?? 0) > 0;
}

/** A profile is complete once the user has picked a username and a photo (same as Flutter). */
export function isProfileComplete(user: User | null | undefined): boolean {
  return userHasUsername(user) && userHasProfilePhoto(user);
}
